const YEARS_BACK = 20;
const YEARS_AHEAD = 10;

/**
 * Bounds for the month/year dropdowns on the advanced search date pickers.
 *
 * Without them react-day-picker offers 100 years back through the end of the
 * current year, so future dates can't be reached from the year dropdown at all.
 */
export function dateNavBounds() {
  const year = new Date().getFullYear();

  return {
    startMonth: new Date(year - YEARS_BACK, 0),
    endMonth: new Date(year + YEARS_AHEAD, 11),
  };
}
